import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { Button } from "../../components/controls/Button/Button";
import TextInput from "../../components/controls/TextInput";
import { OnestNormalDefault } from "../../components/styled/TextComponents";
import { PageTitle } from "../../components/text/PageTitle";
import Config from "../../Config";
import { setUser } from "../../store/UserSlice";
import PersonalDefaultPage from "./PersonalDefaultPage";

import { FormPhoneInput } from "../../components/inputs/FormTextInput/FormPhoneInput";
import { changeActive } from "../../store/FaqSlice";
import { validatePhone } from "../../utilities/validatePhone";

import {
  color_grey_dark,
  color_grey_light,
  color_red_default,
  color_transparent,
  color_white,
} from "../../constants/colors";
import { useWindowDimensions } from "../../utils";

import ModalSimple from "../../components/blocks/ModalSimple";
import FaqQuestion from "../../components/faq/FaqQuestion";
import { useI18n } from "../../i18n/I18nProvider";

const SupportPage = () => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();

  const dispatch = useDispatch();

  const userData = useSelector((state) => state.user);
  const faqData = useSelector((state) => state.faq);

  // Разделение состояния на отдельные поля
  const [theme, setTheme] = useState("");
  const [question, setQuestion] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isModalSimpleOpen, setIsModalSimpleOpen] = useState(false);
  const handleCloseModalSimple = useCallback(() => {
    setIsModalSimpleOpen(false);
  }, []);
  const [ModalSimpleH, setModalSimpleH] = useState(t("Ваш запрос отправлен!"));
  const [ModalSimpleP, setModalSimpleP] = useState(
    t("Мы получили ваш запрос и ответим в ближайшее время"),
  );
  const [ModalSimpleType, setModalSimpleType] = useState("success");
  const [ModalSimpleButtonText, setModalSimpleButtonText] = useState(t("Закрыть"));

  useEffect(() => {
    console.warn("userData: ", userData.email);
    setEmail(userData.email);
    setPhone(userData.phoneNumber);
  }, [userData]);

  const handleThemeChange = (e) => setTheme(e.target.value);
  const handleQuestionChange = (e) => setQuestion(e.target.value);
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePhoneChange = (e) => setPhone(e.target.value);

  const sendSupportRequest = useCallback(() => {
    const formData = { theme, question, email, phone };
    axios
      .post(Config.BACKEND_ADDR + "/support/new_request", formData)
      .then((response) => {
        if (response.status === 200) {
          setTheme("");
          setQuestion("");
          setModalSimpleH(t("Обращение создано!"));
          setModalSimpleP(t("Служба поддержки свяжется с Вами в ближайшее время"));
          setModalSimpleType("success");
          setIsModalSimpleOpen(true);
          setModalSimpleButtonText(t("Закрыть"));
        } else {
          setModalSimpleH(t("Упс! Что-то пошло не так, попробуйте снова"));
          setModalSimpleP("");
          setModalSimpleType("error");
          setIsModalSimpleOpen(true);
          setModalSimpleButtonText(t("Попробовать снова"));
        }
      })
      .catch(() => {
        setModalSimpleH(t("Упс! Что-то пошло не так, попробуйте снова"));
        setModalSimpleP("");
        setModalSimpleType("error");
        setIsModalSimpleOpen(true);
        setModalSimpleButtonText(t("Попробовать снова"));
      });
  }, [theme, question, email, phone, t]);

  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneValidation = validatePhone(phone);
    setIsFormValid(
      theme.trim() !== "" &&
        question.trim() !== "" &&
        email.trim() !== "" &&
        emailRegex.test(email) &&
        phone.trim() !== "" &&
        phoneValidation.valid,
    );
  }, [theme, question, email, phone]);

  const onChangeFaqQuestionClickButton = (question) => {
    if (question.active) {
      dispatch(changeActive(null));
    } else {
      dispatch(changeActive(question.id));
    }
  };

  useEffect(() => {
    (async () => {
      console.log("navbaruser ", userData);
      if (!userData || Object.keys(userData).length === 0) {
        try {
          const data = await get_user();
          dispatch(setUser(data));
        } catch (error) {
          console.error("Error fetching user data:", error);
          // Обработка ошибки, например, перенаправление на страницу входа
          //navigate('/auth/login');
        }
      }
    })();
  }, [dispatch, userData]);

  return (
    <PersonalDefaultPage>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: screenWidth > 610 ? 520 : screenWidth - 60,
        }}
      >
        <ModalSimple
          type={ModalSimpleType}
          h2={ModalSimpleH}
          p={ModalSimpleP}
          isOpen={isModalSimpleOpen}
          onClose={handleCloseModalSimple}
          buttonText={ModalSimpleButtonText}
        />
        <PageTitle title={t("Новое обращение")} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
            width: screenWidth > 610 ? 520 : screenWidth - 60,
          }}
        >
          <TextInput
            title={t("Тема")}
            placeholder={t("Введите тему сообщения")}
            height={48}
            width={screenWidth > 610 ? 520 : screenWidth - 90}
            multiline={false}
            inputBackgroundColor={color_white}
            value={theme}
            onChange={handleThemeChange}
          />
          <TextInput
            title={t("Ваш вопрос")}
            placeholder={t("Сформулируйте ваш вопрос как можно более подробно...")}
            height={162} //222
            width={screenWidth > 610 ? 520 : screenWidth - 90}
            multiline={true}
            inputBackgroundColor={color_white}
            value={question}
            onChange={handleQuestionChange}
          />
          <TextInput
            title={t("E-mail")}
            placeholder={"example@mail.ru"}
            type="text"
            height={48}
            width={screenWidth > 610 ? 520 : screenWidth - 90}
            multiline={false}
            inputBackgroundColor={color_white}
            value={email}
            onChange={handleEmailChange}
          />
          <div>
            <FormPhoneInput
              placeholder={userData?.phoneNumber || "+7 (___) ___ __ __"}
              type={"tel"}
              title={t("Номер, привязанный к WhatsApp")}
              titleStyle="semiBold"
              value={phone}
              width={screenWidth > 610 ? 520 + 30 : screenWidth - 90 + 30}
              inputBackgroundColor={color_white}
              onChange={handlePhoneChange}
            />
            <div style={{ minHeight: 18, marginTop: 2 }}>
              {phone &&
                phone.replace(/\D/g, "").length > 0 &&
                !validatePhone(phone).valid && (
                  <OnestNormalDefault
                    style={{
                      color: color_red_default,
                      fontSize: 14,
                    }}
                  >
                    {t(validatePhone(phone).error)}
                  </OnestNormalDefault>
                )}
            </div>
          </div>
          <OnestNormalDefault
            style={{ color: color_grey_dark, marginTop: -10 }}
          >
            {t("На него пришлём ответ")}{" "}
          </OnestNormalDefault>
          <Button
            outline={false}
            width={202}
            height={38}
            disabled={!isFormValid}
            backgroundColor={
              !isFormValid ? color_grey_light : color_red_default
            }
            color={color_white}
            borderColor={color_transparent}
            fontSize={16}
            type={"submit"}
            onClick={sendSupportRequest}
            style={{
              borderWidth: 0,
            }}
          >
            {t("Создать обращение")}
          </Button>
          <OnestNormalDefault style={{ color: color_grey_dark }}>
            {t("Часы работы службы поддержки с 10:00 до 17:00 по Мск, с понедельника по пятницу. Суббота и воскресенье нерабочие. Среднее время ответа на обращение - в течение одного рабочего дня, не считая дня подачи обращения.")}
          </OnestNormalDefault>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <PageTitle title={t("FAQ")} />
        <div
          style={{
            width: screenWidth > 610 ? 520 : screenWidth - 60,
            borderRadius: 20,
            padding: 25,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: 30,
            backgroundColor: color_white,
          }}
        >
          {faqData.map((el) => (
            <FaqQuestion
              key={el.id}
              question={el}
              onChangeFaqQuestionClickButton={onChangeFaqQuestionClickButton}
            />
          ))}
        </div>
      </div>
    </PersonalDefaultPage>
  );
};

export default SupportPage;
